import { render, staticRenderFns } from "./DialogTitle.vue?vue&type=template&id=bf2e50f2&scoped=true&"
import script from "./DialogTitle.vue?vue&type=script&lang=ts&"
export * from "./DialogTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2e50f2",
  null
  
)

export default component.exports